// Taille maximum autorisée pour les fichiers joints, en Mo
export const MAX_UPLOAD_FILESIZE = +(
  import.meta.env.VITE_MAX_ATTACHMENT_FILESIZE || 25
);

export const MAX_UPLOAD_FILESIZE_BYTES = MAX_UPLOAD_FILESIZE * 1024 * 1024;

// Types MIME de fichiers autorisés pour les fichiers joints
export const ALLOWED_FILE_TYPES = [
  'text/plain', // Fichiers texte
  'image/jpeg', // Images JPEG
  'image/png', // Images PNG
  'application/pdf', // Fichiers .pdf
  'application/msword', // Microsoft Word .doc
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // Microsoft Word (OpenXML) .docx
];

// Extensions de fichiers autorisés pour l'upload
export const ALLOWED_FILE_EXTENSIONS = [
  'jpg',
  'png',
  'pdf',
  'doc',
  'docx',
  'xls',
  'xlsx',
  'ppt',
  'pptx',
];
